import { render } from "./AppBaseSearch.vue?vue&type=template&id=39c343d1&scoped=true"
import script from "./AppBaseSearch.vue?vue&type=script&lang=js"
export * from "./AppBaseSearch.vue?vue&type=script&lang=js"

import "./AppBaseSearch.vue?vue&type=style&index=0&id=39c343d1&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c343d1"]])

export default __exports__